import React from "react";
import p2 from "../asset/img/2.jpg";
import p3 from "../asset/img/3.jpg";
import p4 from "../asset/img/4.jpg";
import p5 from "../asset/img/5.jpg";
import p6 from "../asset/img/6.jpg";
import p7 from "../asset/img/7.jpg";
import piz from "../asset/img/piz.webp";
import fru from "../asset/img/Fruit.jpg";
import chik from "../asset/img/chik.webp";
import Typed from "react-typed";
import "../styles/menu.css";
import { Link } from "react-router-dom";
export default function menu() {
  return (
    <div>
      <section id="food">
        <h2 id="headName">
          <Typed
            strings={["Types of food Available"]}
            typeSpeed={100}
            backSpeed={50}
            loop
          />
        </h2>
        <div className="food-container container">
          <div className="food-type fruits">
            <div className="img-container">
              <img src={fru} alt="" />
              <div className="img-content">
                <h3>Fruits</h3>
                <Link to="/menu" className="bt">
                  Order Now !
                </Link>
              </div>
            </div>
          </div>
          <div className="food-type vegetables">
            <div className="img-container">
              <img src={piz} alt="" />
              <div className="img-content">
                <h3>Fast Food</h3>{" "}
                <Link to="/menu" className="bt">
                  {" "}
                  Order Now !
                </Link>
              </div>
            </div>
          </div>
          <div className="food-type grains">
            <div className="img-container">
              <img src={chik} alt="" />
              <div className="img-content">
                <h3>Chicken</h3>
                <Link to="/menu" className="bt">
                  {" "}
                  Order Now !
                </Link>
              </div>
            </div>
          </div>
        </div>
      </section>

      <section id="food-menu">
        <h2 className="food-menu-heading">Food Menu</h2>
        <div className="food-menu-container container">
          <div className="food-menu-item food-menu-item1">
            <div className="food-image">
              <img src={p2} alt="" />
            </div>
            <div className="food-description">
              <h2 className="food-title">Food Menu Item 1</h2>
              <p>
                Lorem ipsum dolor sit amet consectetur adipisicing elit. Nobis,
                officiis.
              </p>
              <p className="food-price">Price : &#8377; 250</p>
            </div>
          </div>
          <div className="food-menu-item food-menu-item2">
            <div className="food-image">
              <img src={p3} alt="" />
            </div>
            <div className="food-description">
              <h2 className="food-title">Food Menu Item 2</h2>
              <p>
                Lorem ipsum dolor sit amet consectetur adipisicing elit. Nobis,
                officiis.
              </p>
              <p className="food-price">Price : &#8377; 260</p>
            </div>
          </div>
          <div className="food-menu-item food-menu-item3">
            <div className="food-image">
              <img src={p4} alt="" />
            </div>
            <div className="food-description">
              <h2 className="food-title">Food Menu Item 3</h2>
              <p>
                Lorem ipsum dolor sit amet consectetur adipisicing elit. Nobis,
                officiis.
              </p>
              <p className="food-price">Price : &#8377; 270</p>
            </div>
          </div>
          <div className="food-menu-item food-menu-item4">
            <div className="food-image">
              <img src={p5} alt="" />
            </div>
            <div className="food-description">
              <h2 className="food-title">Food Menu Item 4</h2>
              <p>
                Lorem ipsum dolor sit amet consectetur adipisicing elit. Nobis,
                officiis.
              </p>
              <p className="food-price">Price : &#8377; 150</p>
            </div>
          </div>
          <div className="food-menu-item food-menu-item5">
            <div className="food-image">
              <img src={p6} alt="" />
            </div>
            <div className="food-description">
              <h2 className="food-title">Food Menu Item 5</h2>
              <p>
                Lorem ipsum dolor sit amet consectetur adipisicing elit. Nobis,
                officiis.
              </p>
              <p className="food-price">Price : &#8377; 270</p>
            </div>
          </div>
          <div className="food-menu-item food-menu-item6">
            <div className="food-image">
              <img src={p7} alt="" />
            </div>
            <div className="food-description">
              <h2 className="food-title">Food Menu Item 6</h2>
              <p>
                Lorem ipsum dolor sit amet consectetur adipisicing elit. Nobis,
                officiis.
              </p>
              <p className="food-price">Price : &#8377; 230</p>
            </div>
          </div>
        </div>
      </section>
    </div>
  );
}
